export default function TaglineBar() {
  return;
}